export default "<router-outlet></router-outlet>\r\n<app-loader></app-loader>"